import { VENDOR } from '../../../lib/utils/vendors'
import { Handle, Position, useOnViewportChange, useReactFlow, Viewport } from 'reactflow'
import React, { useMemo, useRef, useState } from 'react'
import classNames from 'classnames'
import { motion } from 'framer-motion'
import { useAudienceFlowDiagramState } from '../../Audiences/AudienceDetails/AudienceFlowDiagram'
import { useAudienceMetricsState } from '../../../pages/Dashboard/Dealer/Audiences/Audience/AudienceDetails'
import { useSearchParams } from 'react-router-dom'

const DestinationNodeCampaign = ({ data, ...rest }: any) => {
  const { selectedNode, setSelectedNode } = useAudienceFlowDiagramState()
  const isSelected = useMemo(
    () => selectedNode?.id === rest?.id,
    [selectedNode, rest?.id],
  )

  const { setFilters } = useAudienceMetricsState()
  const className = classNames(
    'shadow-md rounded-full px-5 py-3 font-bold nodrag border-primary-xiketic border-2',
    {
      'text-white bg-primary-xiketic': isSelected,
      'text-primary-xiketic bg-white': !isSelected,
    },
  )
  const [searchParams, setSearchParams] = useSearchParams()
  return (
    <motion.div
      whileHover={{
        scale: 1.1,
      }}
      whileTap={{ scale: 1.085 }}
      className={className}
      onClick={(e) => {
        e.preventDefault()
        if (isSelected) {
          searchParams.delete('campaign_id')
          setSearchParams(searchParams)
          setSelectedNode({ id: 'this-audience', data: { name: 'This audience' } })
          setFilters((prev) => ({
            ...prev,
            vendor_account_id: undefined,
            vendor_campaign_id: undefined,
          }))
        } else {
          setSelectedNode({ ...rest, data })
          searchParams.set('campaign_id', data.vendor_campaign_id)
          setSearchParams(searchParams)
          setFilters((prev) => ({
            ...prev,
            vendor_account_id: data.vendor_account_id,
            vendor_campaign_id: data.vendor_campaign_id,
          }))
        }
      }}>
      <div className="flex items-center gap-4">
        <div>
          <div>{data.name}</div>
        </div>
        <Handle type="target" position={Position.Left} className="" />
      </div>
    </motion.div>
  )
}
export default DestinationNodeCampaign
